// @flow

import React, {useState} from 'react';
import {useLocation} from 'react-router-dom';
import {PaymentElement, useStripe, useElements} from '@stripe/react-stripe-js';
import PaymentFailureModal from '../Modals/PaymentFailureModal';

import queryString from 'query-string';
import {makeStyles} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';

type Props = {
  inlineError?: boolean,
  setIsPaying: boolean => void,
  setStripeReady: boolean => void,
  type?: string,
  planSelectedId?: string,
  userCardProfileId?: string,
  additionalParams?: {[key: string]: string},
};

const useStyles = makeStyles(() => ({
  error: {
    color: colors.error,
  },
}));

export default function CheckoutForm(props: Props) {
  const {
    additionalParams = {},
    inlineError = false,
    setIsPaying,
    setStripeReady,
    type,
    planSelectedId,
    userCardProfileId,
  } = props;

  const classes = useStyles();
  const location = useLocation();
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsPaying(true);

    let result;

    if (type !== 'save_card') {
      result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/admin`,
        },
      });
    } else {
      let search: any = queryString.parse(location.search);
      if (planSelectedId) search.plan_selected = planSelectedId;
      if (userCardProfileId) search.card_profile = userCardProfileId;
      search = {...search, ...additionalParams};

      result = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}${
            window.location.pathname
          }?${queryString.stringify(search)}`,
        },
      });
    }

    // console.log('RESULT:', result);

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.

    // For inputs validation
    if (result.error.type === 'validation_error') {
      setIsPaying(false);
      return;
    }

    if (result.error.type === 'card_error') {
      setErrorMessage(result.error.message);
    } else if (result.error.message) {
      setErrorMessage(result.error.message);
    } else {
      setErrorMessage('An unexpected error occured.');
    }
    setIsPaying(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement
        id="payment-element"
        onReady={() => setStripeReady(true)}
      />
      {/* Show any error or success messages */}
      {inlineError && !!errorMessage && (
        <p className={classes.error}>{errorMessage}</p>
      )}
      {/* {message && <div id="payment-message">{message}</div>} */}
      {!!errorMessage && !inlineError && (
        <PaymentFailureModal
          open={!!errorMessage}
          handleClose={() => setErrorMessage(null)}
          error={errorMessage}
        />
      )}
    </form>
  );
}
